import { QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      throwOnError: (error, query) => {
        console.error(`error from query ${query.queryHash}: `, error);
        return false;
      },
    },
  },
});
const getQueryClient = () => queryClient;

export default getQueryClient;
